<template>
    <div :class="[{loading: Export.loading}, 'modal-window width-d']">
        <div class="modal-title">
            <h3 class="mt0 mb0">Export '{{ $root.PROJECT }}'</h3>
        </div>
        <hr class="mb15">
        <div class="modal-body"
                :title="limitReached ? 'Delete a previous export to continue exporting again' : ''">
            <div :class="[{disabled: limitReached}, 'form-container']">
                <form name="export" @submit.prevent="makeExport($event)">
                    <div v-if="!limitReached">
                        <label class="col-xs-12 col-sm-6">
                            Name your exported file
                            <tooltip-icon
                                :icon="['fas', 'info-circle']"
                                :text="tooltips.file.text"
                                :shown="tooltips.file.active"
                                position="right"
                                classes="small notify"></tooltip-icon>
                            <div class="clearfix mb5"></div>
                            <input type="text"
                                placeholder="eg: added-payment-flow"
                                ref="exportName"
                                v-model="name"
                                @input="$event.target.classList.remove('error')"
                                class="form-input">
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <label class="inline-input col-xs-6 col-sm-6 text-right">
                            <input
                                type="checkbox"
                                v-model="exportingAll"
                                style="width:18px;height:18px;display:inline-block;vertical-align:middle;"> Export all
                        </label>
                        <label class="inline-input col-xs-6 col-sm-6 text-right">
                            <input
                                type="checkbox"
                                v-model="withConfigs"
                                true-value="1"
                                false-value="0"
                                style="width:18px;height:18px;display:inline-block;vertical-align:middle;margin-left:30px;"> Include configurations
                        </label>
                        <label class="inline-input col-xs-6 col-sm-6 text-right">
                            <input
                                type="checkbox"
                                v-model="withTranslate"
                                true-value="1"
                                false-value="0"
                                style="width:18px;height:18px;display:inline-block;vertical-align:middle;margin-left:30px;"> Include translations
                        </label>
                        <label class="inline-input col-xs-6 col-sm-6 text-right">
                            <input
                                type="checkbox"
                                v-model="withUploads"
                                true-value="1"
                                false-value="0"
                                style="width:18px;height:18px;display:inline-block;vertical-align:middle;margin-left:30px;"> Include uploads content
                        </label>
                        <div class="clearfix mb15"></div>
                    </div>
                    <div class="custom-export"
                        v-if="!exportingAll">
                        <p class="mt0 mb5"><small>Add certain pages for export:</small></p>
                        <select
                            class="export-pages"
                            v-model="page"
                            ref="pageSelector"
                            @change="addExportPage(page)">
                            <option value="">Select page</option>
                            <option
                                :key="p.Id"
                                v-for="p in selectorPages">
                                {{ p.Name }}
                            </option>
                        </select>
                        <div class="clearfix"></div>
                        <p class="mb0"><small>Pages to export:</small></p>
                        <div class="export-pages-container">
                            <ul class="">
                                <li class="no-pages" v-if="!exportPages.length">No pages added for export</li>
                                <li
                                    :key="page.Id"
                                    v-for="(page, idx) in exportPages">{{ page.Name }}
                                    <a href="#"
                                        @click.prevent="cancelExportPage(page, idx)">
                                        <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="clearfix" :class="{mb10: !exportingAll}"></div>

                    <label :class="{ml10: showExportsList}" style="background-color:#fff;padding: 0 0.5em 0 0;">
                        <font-awesome-icon
                            :icon="['fas', 'caret-right']"
                            style="display:inline-block;vertical-align:bottom;"></font-awesome-icon>
                        &nbsp;
                        <span class="title mt0 mb10">
                            <small>Show previous exports</small>
                            &nbsp;<tooltip-icon
                                :text="tooltips.exports.text + '. Max limit: ' + Export.limit"
                                position="right"
                                :shown="tooltips.exports.active"
                                classes="small notify"></tooltip-icon>
                        </span>
                        <input type="checkbox" v-model="showExportsList" style="display:none;">
                    </label>
                    <div v-show="showExportsList" class="exports-list-container">
                        <div class="clearfix mb10"></div>
                        <ul class="exports-list">
                            <li
                                :key="exp.Id"
                                v-for="(exp) in Export.items"
                                class="list-entry">
                                <span class="ellipsis" :title="formattedName(exp)">
                                    {{ formattedName(exp) }}
                                </span>
                                &nbsp;&nbsp;
                                <a href="#" @click.prevent="deleteExport(exp)" class="closex" title="delete archive">
                                    <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
                                </a>
                                <a
                                    :href="$root.CMS_BASE_URL + '/cms/export/' + exp.Id"
                                    class="dwnx"
                                    title="download archive"
                                    target="_blank">
                                    <font-awesome-icon :icon="['fas', 'download']"></font-awesome-icon>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="clearfix mb0"></div>
                    <hr :class="{mt20: showExportsList}">
                    <p style="text-align:right;">
                        <span>
                            <div v-if="withConfigs === '1'" style="margin-bottom:15px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="small danger"></font-awesome-icon>
                                Please keep in mind that <strong>the exported configurations will overwrite the existing ones</strong> inside the destination project, where this archive will be imported
                            </div>
                            <font-awesome-icon
                                :icon="['fas', 'info-circle']"
                                :class="[
                                    'small',
                                    {
                                        notify: exportingAll || (!exportingAll && exportPages.length),
                                        danger: !exportingAll && !exportPages.length || limitReached
                                    }
                                ]">
                            </font-awesome-icon>&nbsp;<span v-if="!limitReached">Currently exporting
                                <span v-if="exportingAll">all</span>
                                <span v-else>{{exportPages.length ? exportPages.length : 'no'}}</span> {{ exportPages.length === 1 ? 'page' : 'pages' }}
                                <span v-if="exportingAll">and all snippets</span>
                                <span v-if="!exportingAll && exportPages.length">and all contained snippets</span>
                            </span>
                        </span>
                        <span v-if="limitReached">
                            Reached the limit of {{ Export.limit }} exports. Please delete at least one previous entry to be able to export again
                        </span>
                    </p>
                    <div class="clearfix mb15"></div>
                    <div v-if="!limitReached" class="action text-right">
                        <button type="button" class="btn btn-grey cancel-btn" @click="$store.dispatch('closeModal')">Cancel</button>
                        &nbsp;&nbsp;
                        <button
                            type="submit"
                            class="btn btn-green export-btn"
                            :disabled="!exportingAll && !exportPages.length">Export</button>
                    </div>
                </form>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import TooltipIcon from '@/components/TooltipIcon'

const tooltips = {
	exports: {
		text: 'All exports will be saved and shown here for future reference until you manually delete them',
		active: false
	},
	file: {
		text: 'Set a descriptive and unique name for the archive file of your export. We will automatically add the date for easy future reference',
		active: false
	}
}

export default {
	components: {
		'tooltip-icon': TooltipIcon
	},
	data () {
		return {
			tooltips,
			exportingAll: true,
			withTranslate: '0',
			withConfigs: '0',
			withUploads: '1',
			showExportsList: false,
			name: '',
			page: '',
			exportPages: []
		}
	},
	computed: {
		...mapState([ 'Export', 'Pages' ]),
		limitReached () {
			return this.Export.items.length === this.Export.limit
		},
		selectorPages () {
			return this.Pages.pages.filter(page => {
				return this.exportPages.indexOf(page) < 0
			})
		}
	},
	watch: {
		'limitReached' () {
			if (this.limitReached) {
				this.showExportsList = this.Export.items.length
			}
		},
		immediate: true
	},
	methods: {
		preMount () {
			this.$store.dispatch('Export/fetchAll')
			this.$store.dispatch('Pages/fetchAll')
		},
		formattedName (exp) {
			const arr = exp.Name.split('_')
			return `${exp.Name.split('_from')[0]} - ${arr[arr.length - 1]}`
		},
		deleteExport (exp) {
			const confirm = window.confirm('Delete export entry: ' + this.formattedName(exp) + '?')
			if (confirm) {
				this.$store.dispatch('Export/delete', { id: exp.Id })
			}
		},
		makeExport () {
			// check for export name
			if (!this.name) {
				this.$refs.exportName.classList.add('error')
				return this.$store.commit('Toast/_addError', 'Please provide an export name')
			}
			// check if custom export but no pages selected
			if (!this.exportingAll && !this.exportPages.length) {
				this.$refs.pageSelector.classList.add('error')
				return this.$store.commit('Toast/_addError', 'Please select at least one page to export')
			}
			// payload data object
			const data = {
				Name: this.name,
				withConfiguration: this.withConfigs === '1' ? '1' : '0',
				WithTranslate: this.withTranslate === '1' ? '1' : '0',
				WithUploads: this.withUploads === '1' ? '1' : '0'
			}
			// if exporting certain pages
			if (!this.exportingAll) {
				const pageIds = this.exportPages.map(p => p.Id)
				pageIds.forEach((pageId, idx) => {
					data[`Pages[${idx}]`] = pageId
				})
			}
			// export request
			this.$store.dispatch('Export/export', data)
			// reset export name input
			this.name = ''
		},
		addExportPage (page) {
			this.$refs.pageSelector.classList.remove('error')
			this.exportPages.push(this.Pages.pages.filter(p => p.Name === page)[0])
			this.page = ''
		},
		cancelExportPage (page, index) {
			this.$delete(this.exportPages, index)
		}
	},
	beforeMount () {
		this.preMount()
	},
	mounted () {
		if (this.$refs.exportName) this.$refs.exportName.focus()
	}
}
</script>
<style lang="scss">
@import '@/styles/modules/_export.scss'
</style>
